<template>
  <div data-v-61a108b8="" class="match-list-container" :class="{'jinri':int_marketToggle==1 && !isOtr, 'guanjun':isOtr}">
    <div id="scheduleTabs" class="schedule-tabs">
      <div class="schedule-tab" :class="{ 'active':matchSchdTab==1 }" data-tab="all" @click="changeMarket(1)">{{ arr_lang.result['RESULT.ALL'] }}</div>
      <div class="schedule-tab" :class="{ 'active':matchSchdTab==2 }" data-tab="live" @click="changeMarket(2)">{{ arr_lang.result['RESULT.RUNNING'] }}</div>
      <div class="schedule-tab" :class="{ 'active':matchSchdTab==3 }" data-tab="ended" @click="changeMarket(3)">{{ arr_lang.result['RESULT.FINISH'] }}</div>
      <div class="schedule-tab" :class="{ 'active':matchSchdTab==4 }" data-tab="upcoming" @click="changeMarket(4)">{{ arr_lang.sportTable['SPORT_TABLE.NOT_STARTED'] }}</div>
    </div>
    <refreshScreen :loading="refreshScreen" :edition="editionStand" :stemplate="arr_selectedTemplate"></refreshScreen>
    <simpleSoccerTable :is-odds-switch="isOddsSwitch"></simpleSoccerTable>
    <backToTop></backToTop>
  </div>
</template>

<script>
import {
    mapGetters
  } from 'vuex'

  import EventBus from '@/vue/events/event-bus'
  import backToTop from '../core/backToTop'
  import scrollEnd from '../core/scrollEnd'
  import moment from 'moment'
  import refreshScreen from '@/vue/components/refreshScreen'
  import simpleSoccerTable from './simpleSoccerTable'
  export default {
    props: {
      isOddsSwitch: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters([
        // 'arr_sportList'
        'arr_selectedTemplate',
        'skinTheme',
        'editionStand',
        'loadingScreen',
        'sortedEvents',
        'arr_lang',
        'refreshScreen',
        'titleSport',
        'int_marketToggle',
        'isOtr',
        'matchSchdTab',
        'selected_date',
      ]),
    },
    components:{
      backToTop,
      refreshScreen,
      simpleSoccerTable,
      scrollEnd,
    },
    data() {
			return {
				heightPX : window.innerHeight-155,
        gameBanner : window._gameBanner
			}
		},
    methods: {
      // checkTitle(title, sportId){
      //   return _.includes(title, sportId.toString())
      // },
      changeMarket(val) {
        EventBus.$emit('changeMarketTab', val, this.selected_date)
      },
    },
    beforeMount(){
     
    },
  }
</script>



// WEBPACK FOOTER //
// resources/score/vue/apps/sport/contentSport.vue